<template>
  <div id="homecare-project" style="width: 100%">
    <!-- <pre>{{ lowList }}</pre> -->
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="report-date-filter text-end">
          <span class="me-3">คัดกรองจากวันที่</span>
          <el-date-picker
            v-model="defaultReportDate"
            format="dd-MM-yyyy HH:mm"
            start-placeholder="เริ่ม"
            end-placeholder="สิ้นสุด"
            range-separator="ถึง"
            type="datetimerange"
            @change="dateFilter"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="text-end">
          <download-excel
            :fields="statField"
            :data="statData"
            class="sc-btn sc-btn-outline"
            type="xls"
            name="project-homecare-stat.xls"
            >ดาวน์โหลดข้อมูลโครงการ</download-excel
          >
        </div>
      </div>
    </div>
    <div class="row col mt-3 px-0 mx-0 content-list">
      <div class="col-6 d-flex" style="height: 100%">
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-warning text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.low_rise") }}
              </div>
              <div class="ms-3">
                <search-input
                  :placeholder="
                    $t('feature.homecare.search.project_title_or_project_code')
                  "
                  @search="lowChange"
                ></search-input>
              </div>
            </div>
          </div>
          <ul v-if="isInitSuccess" class="list-group list-group-flush">
            <li
              v-for="home in lowList"
              :key="home.projectId"
              class="list-group-item"
              @click="selectProject(home)"
            >
              <div class="media">
                <div class="me-2">
                  <img :src="home.projectIcon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ home.projectName }}
                  </div>
                  <div class="h5">
                    {{ home.projectLocation }}
                  </div>
                </div>
                <div class="ms-3 mt-2 h3">
                  {{ home.projectCode }}
                </div>
                <div class="ms-2 mt-1">
                  <span v-show="home.unread > 0" class="px-2 badge">{{
                    home.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div v-if="home.statData" class="stat">
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมทั้งหมด</h6>
                  <div class="count">{{ home.statData.countAllStatus }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">{{ home.statData.item_cnc }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมที่เสร็จสิ้น</h6>
                  <div class="count">{{ home.statData.item_cls }}</div>
                </div>
              </div>
              <div v-else class="stat">
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมทั้งหมด</h6>
                  <div class="count">-</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">-</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมที่เสร็จสิ้น</h6>
                  <div class="count">-</div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl"><strong>จำนวนงานซ่อมทั้งหมด</strong></h6>
                  <div class="count">
                    {{ totalHomeCareStatLow.countAllStatus }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">{{ totalHomeCareStatLow.item_cnc }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานซ่อมที่เสร็จสิ้น</strong>
                  </h6>
                  <div class="count">{{ totalHomeCareStatLow.item_cls }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-6 d-flex" style="height: 100%">
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-success text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.high_rise") }}
              </div>
              <div class="ms-3">
                <search-input
                  :placeholder="
                    $t('feature.homecare.search.project_title_or_project_code')
                  "
                  @search="highChange"
                ></search-input>
              </div>
            </div>
          </div>
          <ul v-if="isInitSuccess" class="list-group list-group-flush">
            <li
              v-for="home in highList"
              :key="home.projectId"
              class="list-group-item"
              @click="selectProject(home)"
            >
              <div class="media">
                <div class="me-2">
                  <img :src="home.projectIcon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ home.projectName }}
                  </div>
                  <div class="h5">
                    {{ home.projectLocation }}
                  </div>
                </div>
                <div class="ms-3 mt-2 h3">
                  {{ home.projectCode }}
                </div>
                <div class="ms-2 mt-1">
                  <span v-show="home.unread > 0" class="px-2 badge">{{
                    home.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div v-if="home.statData" class="stat">
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมทั้งหมด</h6>
                  <div class="count">{{ home.statData.countAllStatus }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">{{ home.statData.item_cnc }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมที่เสร็จสิ้น</h6>
                  <div class="count">{{ home.statData.item_cls }}</div>
                </div>
              </div>
              <div v-else class="stat">
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมทั้งหมด</h6>
                  <div class="count">-</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">-</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">จำนวนงานซ่อมที่เสร็จสิ้น</h6>
                  <div class="count">-</div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl"><strong>จำนวนงานซ่อมทั้งหมด</strong></h6>
                  <div class="count">
                    {{ totalHomeCareStatHigh.countAllStatus }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานที่ไม่รับซ่อม</strong>
                  </h6>
                  <div class="count">{{ totalHomeCareStatHigh.item_cnc }}</div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>จำนวนงานซ่อมที่เสร็จสิ้น</strong>
                  </h6>
                  <div class="count">{{ totalHomeCareStatHigh.item_cls }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import JsonExcel from "vue-json-excel";
import { DatePicker } from "element-ui";
import SearchInput from "@/components/helper/SearchInput";
import { projectTypeMapper } from "@/lib/mapper";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    SearchInput,
    downloadExcel: JsonExcel,
    elDatePicker: DatePicker
  },
  data() {
    return {
      lowList: [],
      highList: [],
      totalHomeCareStatLow: {
        countAllStatus: 0,
        item_cls: 0,
        item_cnc: 0,
        item_inp: 0,
        item_opn: 0,
        item_rvw: 0,
        item_winp: 0
      },
      totalHomeCareStatHigh: {
        countAllStatus: 0,
        item_cls: 0,
        item_cnc: 0,
        item_inp: 0,
        item_opn: 0,
        item_rvw: 0,
        item_winp: 0
      },
      unread: [],
      defaultReportDate: ["", ""],
      statField: {
        "Project Name": "projectName",
        "Project Code": "projectCode",
        "Project Type": "projectType",
        "All Status Task": "allStatusTask",
        "Waiting for Staff Review Task": "waitingForStaffReviewTask",
        "Waiting for Fix Task": "waitingForFixTask",
        "Inprogress Task": "inprogressTask",
        "Waiting for Customer Review Task": "waitingForCustomerReviewTask",
        "Reject Task": "rejectTask",
        "Complete Task": "completeTask"
      },
      statData: [],
      statDataEmptyRow: {
        projectName: "",
        projectCode: "",
        projectType: "",
        allStatusTask: "",
        waitingForStaffReviewTask: "",
        waitingForFixTask: "",
        inprogressTask: "",
        waitingForCustomerReviewTask: "",
        rejectTask: "",
        completeTask: ""
      },
      isInitSuccess: false
    };
  },
  async beforeMount() {
    await this.initData();
  },
  methods: {
    compareProjectNameDesc(a, b) {
      if (b.projectName > a.projectName) return -1;
      if (b.projectName < a.projectName) return 1;
      return 0;
    },
    compareByUnreadThenNameDesc(a, b) {
      if (a.unread - b.unread === 0) {
        return this.compareProjectNameDesc(a, b);
      }
      return b.unread - a.unread;
    },
    // The project list API returns projectId as a string while the homecare
    // count and unread APIs return project_id as a number, so every match
    // between those responses compares the ids as strings.
    isSameProjectId(a, b) {
      return `${a}` === `${b}`;
    },
    async initData() {
      this.isInitSuccess = false;
      await Promise.all([this.getHome(), this.getCondo()]).then(
        async values => {
          await this.getHomecareStat(this.highList, "H");
          this.statData.push(this.statDataEmptyRow);

          this.statData.push({
            projectName: "Project Name",
            projectCode: "Project Code",
            projectType: "Project Type",
            allStatusTask: "All Status Task",
            waitingForStaffReviewTask: "Waiting for Staff Review Task",
            waitingForFixTask: "Waiting for Fix Task",
            inprogressTask: "Inprogress Task",
            waitingForCustomerReviewTask: "Waiting for Customer Review Task",
            rejectTask: "Reject Task",
            completeTask: "Complete Task"
          });
          await this.getHomecareStat(this.lowList, "L");
          this.statData.push(this.statDataEmptyRow);

          this.statData.push({
            projectName: "",
            projectCode: "",
            projectType: "",
            allStatusTask: "All Status Task",
            waitingForStaffReviewTask: "Waiting for Staff Review Task",
            waitingForFixTask: "Waiting for Fix Task",
            inprogressTask: "Inprogress Task",
            waitingForCustomerReviewTask: "Waiting for Customer Review Task",
            rejectTask: "Reject Task",
            completeTask: "Complete Task"
          });

          this.statData.push({
            projectName: "Total Homecare Status Low Rise",
            projectCode: "",
            projectType: "",
            allStatusTask:
              this.totalHomeCareStatLow.countAllStatus +
              this.totalHomeCareStatHigh.countAllStatus,
            waitingForStaffReviewTask:
              this.totalHomeCareStatLow.item_opn +
              this.totalHomeCareStatHigh.item_opn,
            waitingForFixTask:
              this.totalHomeCareStatLow.item_winp +
              this.totalHomeCareStatHigh.item_winp,
            inprogressTask:
              this.totalHomeCareStatLow.item_inp +
              this.totalHomeCareStatHigh.item_inp,
            waitingForCustomerReviewTask:
              this.totalHomeCareStatLow.item_rvw +
              this.totalHomeCareStatHigh.item_rvw,
            rejectTask:
              this.totalHomeCareStatLow.item_cnc +
              this.totalHomeCareStatHigh.item_cnc,
            completeTask:
              this.totalHomeCareStatLow.item_cls +
              this.totalHomeCareStatHigh.item_cls
          });

          await this.getUnread({ lowList: values[0], highList: values[1] });
          this.isInitSuccess = true;
        }
      );
    },
    async dateFilter() {
      this.totalHomeCareStatLow = {
        countAllStatus: 0,
        item_cls: 0,
        item_cnc: 0,
        item_inp: 0,
        item_opn: 0,
        item_rvw: 0,
        item_winp: 0
      };

      this.totalHomeCareStatHigh = {
        countAllStatus: 0,
        item_cls: 0,
        item_cnc: 0,
        item_inp: 0,
        item_opn: 0,
        item_rvw: 0,
        item_winp: 0
      };

      await this.initData();
    },
    getCondo(filter = "") {
      const vm = this;
      return axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          headers: {
            projectId: localStorage.getItem("projectId"),
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: { type: projectTypeMapper.HIGH, searchText: filter }
        })
        .then(res => {
          vm.highList = res.data;
          vm.highList.sort(this.compareProjectNameDesc);

          if (this.unread.length)
            this.setUnreadToProject({ highList: res.data });

          return res.data;
        })
        .catch(e => {
          throw e;
        });
    },
    getHome(filter = "") {
      const vm = this;
      return axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          headers: {
            projectId: localStorage.getItem("projectId"),
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: { type: projectTypeMapper.LOW, searchText: filter }
        })
        .then(res => {
          vm.lowList = res.data;
          vm.lowList.sort(this.compareProjectNameDesc);

          if (this.unread.length)
            this.setUnreadToProject({ lowList: res.data });

          return res.data;
        })
        .catch(e => {
          throw e;
        });
    },
    lowChange(searchText) {
      this.getHome(searchText);
    },
    highChange(searchText) {
      this.getCondo(searchText);
    },
    getUnread({ lowList, highList }) {
      axios
        .get(`${process.env.HOST}/admin/homecares/projects/unread`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        })
        .then(res => {
          this.unread = res.data;
          this.setUnreadToProject({ lowList, highList });
        })
        .catch(e => {
          throw e;
        });
    },
    setUnreadToProject({ lowList, highList }) {
      if (lowList) {
        const lowRise = lowList;
        lowRise.forEach((project, key) => {
          const projectUnread = this.unread.find(unread =>
            this.isSameProjectId(unread.project_id, project.projectId)
          );
          lowRise[key].unread = projectUnread ? projectUnread.unread : 0;
        });

        lowList.sort(this.compareByUnreadThenNameDesc);

        this.lowList = lowRise;
      }

      if (highList) {
        const highRise = highList;
        highRise.forEach((project, key) => {
          const projectUnread = this.unread.find(unread =>
            this.isSameProjectId(unread.project_id, project.projectId)
          );
          highRise[key].unread = projectUnread ? projectUnread.unread : 0;
        });

        highRise.sort(this.compareByUnreadThenNameDesc);

        this.highList = highRise;
      }
    },
    selectProject(home) {
      localStorage.setItem("projectId", home.projectId);
      localStorage.setItem("projectName", home.projectName);
      localStorage.setItem("projectIcon", home.projectIcon);
      this.$router.push({
        name: "Homecare",
        params: { projectId: home.projectId, jobId: "all" }
      });
    },
    async getHomecareStat(projects, type) {
      const projectsData = {
        projectIds: [],
        startDate:
          this.defaultReportDate[0] === "" ? "" : this.defaultReportDate[0],
        endDate:
          this.defaultReportDate[1] === "" ? "" : this.defaultReportDate[1]
      };

      await projects.forEach(project => {
        projectsData.projectIds.push(project.projectId);
      });

      await axios
        .get(
          `${process.env.HOST}/admin/homecares/job-issue/count-by-projects`,
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            },
            params: projectsData
          }
        )
        .then(async res => {
          const homecareStatData = res.data;
          const countAllProjectStatus = {
            countAllStatus: 0,
            item_cls: 0,
            item_cnc: 0,
            item_inp: 0,
            item_opn: 0,
            item_rvw: 0,
            item_winp: 0
          };

          homecareStatData.projects.forEach(data => {
            const index = projects.findIndex(project =>
              this.isSameProjectId(project.projectId, data.project_id)
            );

            // A count row for a project outside this panel's list belongs to
            // neither its cards nor its totals; skipping it also keeps one
            // unmatched id from breaking the whole page.
            if (index === -1) return;

            const resultData = data;
            resultData.countAllStatus =
              data.item_cls +
              data.item_cnc +
              data.item_inp +
              data.item_opn +
              data.item_rvw +
              data.item_winp;

            countAllProjectStatus.item_cls += data.item_cls;
            countAllProjectStatus.item_cnc += data.item_cnc;
            countAllProjectStatus.item_inp += data.item_inp;
            countAllProjectStatus.item_opn += data.item_opn;
            countAllProjectStatus.item_rvw += data.item_rvw;
            countAllProjectStatus.item_winp += data.item_winp;
            countAllProjectStatus.countAllStatus += resultData.countAllStatus;

            if (type === "L") {
              this.lowList[index].statData = resultData;
              this.pushDataToReport(this.lowList[index], type);
            } else if (type === "H") {
              this.highList[index].statData = resultData;
              this.pushDataToReport(this.highList[index], type);
            }
          });

          if (type === "L") {
            this.totalHomeCareStatLow = countAllProjectStatus;
            this.statData.push({
              projectName: "Total Homecare Status Low Rise",
              projectCode: "",
              projectType: "",
              allStatusTask: this.totalHomeCareStatLow.countAllStatus,
              waitingForStaffReviewTask: this.totalHomeCareStatLow.item_opn,
              waitingForFixTask: this.totalHomeCareStatLow.item_winp,
              inprogressTask: this.totalHomeCareStatLow.item_inp,
              waitingForCustomerReviewTask: this.totalHomeCareStatLow.item_rvw,
              rejectTask: this.totalHomeCareStatLow.item_cnc,
              completeTask: this.totalHomeCareStatLow.item_cls
            });
          } else if (type === "H") {
            this.totalHomeCareStatHigh = countAllProjectStatus;
            this.statData.push({
              projectName: "Total Homecare Status High Rise",
              projectCode: "",
              projectType: "",
              allStatusTask: this.totalHomeCareStatHigh.countAllStatus,
              waitingForStaffReviewTask: this.totalHomeCareStatHigh.item_opn,
              waitingForFixTask: this.totalHomeCareStatHigh.item_winp,
              inprogressTask: this.totalHomeCareStatHigh.item_inp,
              waitingForCustomerReviewTask: this.totalHomeCareStatHigh.item_rvw,
              rejectTask: this.totalHomeCareStatHigh.item_cnc,
              completeTask: this.totalHomeCareStatHigh.item_cls
            });
          }
        });
    },
    pushDataToReport(project, type) {
      this.statData.push({
        projectName: project.projectName,
        projectCode: project.projectCode,
        projectType: type,
        allStatusTask: project.statData.countAllStatus,
        waitingForStaffReviewTask: project.statData.item_opn,
        waitingForFixTask: project.statData.item_winp,
        inprogressTask: project.statData.item_inp,
        waitingForCustomerReviewTask: project.statData.item_rvw,
        rejectTask: project.statData.item_cnc,
        completeTask: project.statData.item_cls
      });
    }
  }
};
</script>
<style lang="css" scoped>
#homecare-project {
  border-top: 1px solid #e0e0e0;
  height: calc(100% - 110px);
}

.content-list {
  height: calc(100% - 200px);
}

.card {
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
}
.card .list-group {
  overflow-y: auto;
}
#homecare-project .list-group-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.project-icon {
  width: 40px;
  height: 40px;
  background-color: #eee;
  border-radius: 15px;
  border: #ccc 1px solid;
}

.stat:after {
  display: block;
  content: '';
  clear: both;
}
.stat .col {
  float: left;
  width: 33.33%;
  text-align: center;
  padding: 5px 0 0 0;
  border-right: solid 1px #ccc;
}
.stat .col:last-child {
  border: none;
}
.stat .stat-ttl {
  font-size: 13px;
  margin-bottom: 0;
}
.stat .count {
  font-size: 14px;
  padding: 5px 0;
}
.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}
</style>
